import {Component} from '@angular/core';

@Component({
    selector: 'app-loan-agreement-component-text',
    templateUrl: './loanAgreementText.component.html',
    styleUrls: ['./loanAgreement.component.css']
})
export class LoanAgreementTextComponent {
}